import { all, fork } from 'redux-saga/effects';

import { watchtutorSignUp, watchtutorProfileUpdate} from './Auth';
import { watchgetSchools} from './School';
import { watchgetCities} from './City';
import { watchgetLevels} from './Level';
import { watchgetSubjects} from './Subject';

export default function* rootSaga() {
    yield all([
        fork(watchtutorSignUp),
        fork(watchtutorProfileUpdate),

        fork(watchgetSchools),
        
        fork(watchgetCities),

        fork(watchgetLevels),

        fork(watchgetSubjects),

        
    ]);
}